import * as Yup from 'yup';

export default Yup.object().shape({
  batchNumber: Yup.string().required('Batch number is required'),
  // productName: Yup.string().required('Product name is required'),
  // additionalField: Yup.string().required('Additional field is required'),
  daysSave: Yup.number()
    .required('Days save is required')
    .typeError('Days save must be number')
    .integer('Days save must be integer'),
  comments: Yup.string().max(225, 'Comments maximum length is 225'),
});
